// export const SOCKET_URL = `http://localhost:6001/`;
export const SOCKET_URL = `https://api.server.dev.fulcrum.rocks/`;
